import { Injectable } from '@angular/core';
import { CustomBaseStore } from '@city/const';
import { BaseStoreFacade } from '@city/data-access';
import { filter, take } from 'rxjs/operators';
import { AnalyticsService } from './analytics.service';

@Injectable({ providedIn: 'root' })
export class LoginAnalyticsGaService {
  constructor(
    private analyticsService: AnalyticsService,
    private baseStoreFacade: BaseStoreFacade,
  ) {}

  sendGa(event: string): void {
    this.baseStoreFacade
      .getActiveBaseStore()
      .pipe(filter(Boolean), take(1))
      .subscribe((baseStore: CustomBaseStore) => {
        return this.analyticsService.sendEvent({
          event,
          city: baseStore.name,
        });
      });
  }
}
